<script>
    import { TOKEN_SESSION, USER } from '../stores'
    import { createEventDispatcher } from 'svelte';
    import { onMount } from 'svelte';
    import * as Fx from '../globals/Fx'
    import GLOBALS from "../globals/GLOBALS";

    export let  opciones = ''
    
    let hide = null

    const dispatch = createEventDispatcher()
    
    onMount (async () => {
    })
    
    const _click_opcion = (name) => {
        dispatch('_click_opcion',{opcion : name})
    }

    const _toggleMenu = () => {
        hide = hide === "hide" ? "" : "hide"
    }
    
</script>

<div class="main-menu {hide}">
    {#each opciones as item, i}
        <div class="opc {item.active ? "active" : ""}" on:click={_click_opcion(item.name)} title={item.name}>
            <div class="icon" title={item.name}>
                <ion-icon id="opc-{i}" name="{item.icon}" title={item.name}></ion-icon>
            </div>
            <div class="label">
                {item.desc}
            </div>
        </div>
    {/each}
    <div class="version"> {GLOBALS.version}</div>
</div>

    
<style>
    .main-menu {
        z-index: 999;
        display: flex;
        flex-direction: column;
        position: fixed;
        left : 0px;
        top: 0px;
        color: #34495e55;
        overflow: hidden;
        height: 100%;
        padding-top: 100px;
        transition: height 500ms , justify-content 300ms;
        justify-content: flex-start;
        background-color: #ffffffdd;
        white-space: nowrap;
        width: 55px;
        transition: width 100ms;
    }

    .main-menu:hover {
        width: 280px;
        color: #34495e;
        border-right: 1px solid #efefef;
        border-top: 1px solid #efefef;
        box-shadow: 2px 2px 3px #efefef;
    }

    ion-icon  {
        font-size: 1.3em;
        pointer-events: none;
    }
    
    .opc {
        font-size: 1em;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 8px 30px 8px 5px;
        cursor: pointer;
        border-radius: 0% 25px 25px 0%;
        transition: background-color 500ms;
    }

    .active {
        background-color:#2c3e50 !important;
        color: #fff !important;
    }

    .opc:hover {
        background-color:#14518d33;
        color: #2c3e50;
    }

    .icon, .label {
        display: flex;
        align-items: center;
        margin: 8px 8px 8px 8px;
        font-weight: bold;
    }
    .label {
        margin-left: 16px;
    }

    .version {
        position: absolute;
        bottom: 0;
        left: 14px;
        transform-origin: left;
        transform: rotate(271deg);
    }

</style>